import { SelectButtonDesignTokens } from '@primeng/themes/types/selectbutton';

interface ICustomSelectButtonDesignTokens extends SelectButtonDesignTokens {
  root: SelectButtonDesignTokens['root'] & {
    gap: string;
  };
}

export const baseSelectButtonToken: ICustomSelectButtonDesignTokens = {
  root: {
    borderRadius: '0.25rem',
    gap: '0.375rem',
  },
  css: ({ dt }: { dt: (token: string, val?: string) => string }) => `
      .tabs.p-selectbutton .p-togglebutton .p-togglebutton-content {
        mask-image: linear-gradient(to right, black 85%, transparent);
        -webkit-mask-image: linear-gradient(to right, black 85%, transparent);
        display: block;
        overflow: hidden;
      }
      .tabs.p-selectbutton .p-togglebutton.p-togglebutton-checked .p-togglebutton-content {
        mask-image: none;
        -webkit-mask-image: none;
      }
      .tabs.p-selectbutton .p-togglebutton {
        flex: 1 1 0;
        width: max-content;
        max-width: max-content;
        align-items: center;
        transition-property: background-color, color;
        transition-duration: 300ms;
        transition-timing-function: ease-in-out;
      }
      .tabs.p-selectbutton .p-togglebutton.p-togglebutton-checked {
        flex: 1 0 100%;
      }

      .p-selectbutton {
        gap: ${dt('selectbutton.gap')}
      }
      .p-selectbutton .p-togglebutton {
        border-radius: ${dt('selectbutton.borderRadius')};
        border-width: 0;
      }
    `,
};
